import { useContext, useEffect } from "react";
import BackofficeSocketContext from "Context/BackofficeSocketContext";

const useSocketEvent = (eventName: string, callback: (data: any) => void) => {

  const { subscribe, unsubscribe } = useContext(BackofficeSocketContext);

  useEffect(() => {
    subscribe(eventName, callback);
    return () => { unsubscribe(eventName, callback); };
  }, [eventName, callback, subscribe, unsubscribe]);

};

export default useSocketEvent;
